'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../Image/Image.js');
var slicedToArray = require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');
var components_Box_Box = require('../Box/Box.js');
require('../../defineProperty-3cad0327.js');
require('../../styles/themeUtils.js');
var components_Icon_Icon = require('../../Icon-efcd1bee.js');
var utils_hooks_useDidUpdateEffect = require('../../utils/hooks/useDidUpdateEffect.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  width: 100%;\n  background-color: transparent;\n  text-align: left;\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Header = xstyledStyledComponents_es.styled.button(_templateObject());

function CollapseHeader(_ref) {
  var children = _ref.children,
      iconSize = _ref.iconSize,
      isOpen = _ref.isOpen,
      id = _ref.id,
      handleToggleButton = _ref.handleToggleButton,
      iconToClose = _ref.iconToClose,
      iconToOpen = _ref.iconToOpen;
  var buttonIcon = isOpen ? iconToClose : iconToOpen;
  return /*#__PURE__*/React__default['default'].createElement(Header, {
    id: id,
    type: "button",
    onClick: handleToggleButton,
    "aria-controls": "".concat(id, "-body"),
    "aria-expanded": isOpen
  }, children, /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], {
    marginLeft: "3x"
  }, /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
    name: buttonIcon,
    size: iconSize,
    colorVariant: "black"
  })));
}
CollapseHeader.defaultProps = {
  id: undefined,
  isOpen: false,
  handleToggleButton: function handleToggleButton() {},
  iconSize: 'small',
  iconToClose: 'minus',
  iconToOpen: 'plus',
  children: ''
};
CollapseHeader.propTypes = {
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.string]),
  handleToggleButton: index.propTypes.func,
  iconSize: components_Icon_Icon.IconStructure.propTypes.size,
  iconToClose: index.propTypes.string,
  iconToOpen: index.propTypes.string,
  id: index.propTypes.string,
  isOpen: index.propTypes.bool
};

function CollapseBody(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      id = _ref.id;
  return /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], {
    id: "".concat(id, "-body"),
    display: isOpen ? 'block' : 'none',
    "aria-labelledby": id,
    isOpen: isOpen
  }, children);
}
CollapseBody.defaultProps = {
  id: undefined,
  isOpen: false,
  children: ''
};
CollapseBody.propTypes = {
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.string]),
  id: index.propTypes.string,
  isOpen: index.propTypes.bool
};

function Collapse(_ref) {
  var tag = _ref.tag,
      children = _ref.children,
      className = _ref.className,
      onChange = _ref.onChange,
      initiallyOpen = _ref.initiallyOpen,
      id = _ref.id;

  var _useState = React.useState(initiallyOpen),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      toggleButton = _useState2[1];

  var handleToggleButton = React.useCallback(function () {
    toggleButton(!isOpen);
  }, [isOpen]);

  var onCallback = function onCallback(callback) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (callback) {
      callback(_extends._extends_1({
        isOpen: isOpen
      }, params));
    }
  };

  utils_hooks_useDidUpdateEffect['default'](function () {
    onCallback(onChange);
  }, [isOpen]);
  var collapseId = "collapse-".concat(id);
  return /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], {
    id: id,
    tag: tag,
    className: className,
    borderTop: "2px solid",
    borderTopColor: "black"
  }, React__default['default'].Children.map(children, function (child) {
    return /*#__PURE__*/React__default['default'].cloneElement(child, {
      isOpen: isOpen,
      handleToggleButton: handleToggleButton,
      id: collapseId
    });
  }));
}

Collapse.defaultProps = {
  tag: 'div',
  className: undefined,
  initiallyOpen: false,
  onChange: function onChange() {}
};
Collapse.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string,
  id: index.propTypes.string.isRequired,
  initiallyOpen: index.propTypes.bool,
  onChange: index.propTypes.func,

  /** The actual HTML element to be rendered */
  tag: index.propTypes.elementType
};
Collapse.Header = CollapseHeader;
Collapse.Body = CollapseBody;

exports.default = Collapse;
//# sourceMappingURL=Collapse.js.map
